import { render, staticRenderFns } from "./ArticleText.vue?vue&type=template&id=3f908cd4&"
import script from "./ArticleText.ts?vue&type=script&lang=ts&"
export * from "./ArticleText.ts?vue&type=script&lang=ts&"
import style0 from "./ArticleText.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports